const IsActiveTypeField = ({ item, forTable, rowsItem }) => {
  if (forTable && item.name == 'name') {
    return (
      <div style={{ textDecoration: !rowsItem.value.is_active ? 'line-through' : 'none' }}>
        {' '}
        {rowsItem.value.name}{' '}
      </div>
    );
  }
};

export default IsActiveTypeField;
